/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.224.1-v202611051432-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqDisplaysApiClass {
 
   constructor() {}

  /**
   * @summary Archive a display item
   * @param {string} id - ID of the display item to archive.
  */
  public archiveDisplay(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/displays/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/displays/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a new display item
  */
  public createDisplay(
    body: models.DisplayInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/displays`;
    const urlTemplate = `${baseUrl}/displays`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DisplayOutputV1>;
  }

  /**
   * @summary Get a display item
   * @param {string} id - The Seeq ID for the display
  */
  public getDisplay(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/displays/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/displays/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.DisplayOutputV1>;
  }

  /**
   * @summary Get a list of display items
   * @param {number} [offset=0] - The pagination offset, the index of the first display item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of display items that will be returned in this page of results
  */
  public getDisplays(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/displays`;
    const urlTemplate = `${baseUrl}/displays`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.DisplayOutputListV1>;
  }

  /**
   * @summary Update a display
   * @param {string} id - The Seeq ID for the display
  */
  public updateDisplay(
    body: models.DisplayInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/displays/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/displays/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DisplayOutputV1>;
  }

}


export const sqDisplaysApi = new sqDisplaysApiClass();

export type sqDisplaysApiEndpoints = {
  'archiveDisplay': {
    method: 'delete';
    path: '/displays/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'createDisplay': {
    method: 'post';
    path: '/displays';
    response: models.DisplayOutputV1;
  };
  'getDisplay': {
    method: 'get';
    path: '/displays/${encodeURIComponent(String(id))}';
    response: models.DisplayOutputV1;
  };
  'getDisplays': {
    method: 'get';
    path: '/displays';
    response: models.DisplayOutputListV1;
  };
  'updateDisplay': {
    method: 'post';
    path: '/displays/${encodeURIComponent(String(id))}';
    response: models.DisplayOutputV1;
  };
};

type ApiArchiveDisplayResponse = models.ArchiveOutputV1;
type ApiarchiveDisplayMutationParams = Parameters<typeof sqDisplaysApi.archiveDisplay> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDisplaysApi.archiveDisplay>;

export function useApiArchiveDisplayMutation(
  options?: Omit<UseMutationOptions<ApiArchiveDisplayResponse, AxiosError<SeeqErrorData>,
    ApiarchiveDisplayMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveDisplayResponse, AxiosError<SeeqErrorData>,
  ApiarchiveDisplayMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveDisplayMutationParams) =>
      sqDisplaysApi.archiveDisplay(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateDisplayResponse = models.DisplayOutputV1;
type ApicreateDisplayMutationParams = Parameters<typeof sqDisplaysApi.createDisplay> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDisplaysApi.createDisplay>;
type ApicreateDisplayMutationVariables = models.DisplayInputV1;

export function useApiCreateDisplayMutation(
  options?: Omit<UseMutationOptions<ApiCreateDisplayResponse, AxiosError<SeeqErrorData>,
    ApicreateDisplayMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateDisplayResponse, AxiosError<SeeqErrorData>,
  ApicreateDisplayMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateDisplayMutationVariables) =>
      sqDisplaysApi.createDisplay(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetDisplayResponse = models.DisplayOutputV1;
export function GetDisplayQueryKey(
  params: Parameters<typeof sqDisplaysApi.getDisplay>[0],
) {
  return ['sqDisplaysApi', 'getDisplay', params] as const;
}

export function useApiGetDisplayQuery(
  params: Parameters<typeof sqDisplaysApi.getDisplay>[0],
  options?: Omit<UseQueryOptions<ApiGetDisplayResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetDisplayResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetDisplayQueryKey(params),
    queryFn: () =>
      sqDisplaysApi.getDisplay(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetDisplaysResponse = models.DisplayOutputListV1;
export function GetDisplaysQueryKey(
  params: Parameters<typeof sqDisplaysApi.getDisplays>[0],
) {
  return ['sqDisplaysApi', 'getDisplays', params] as const;
}

export function useApiGetDisplaysQuery(
  params: Parameters<typeof sqDisplaysApi.getDisplays>[0],
  options?: Omit<UseQueryOptions<ApiGetDisplaysResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetDisplaysResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetDisplaysQueryKey(params),
    queryFn: () =>
      sqDisplaysApi.getDisplays(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiUpdateDisplayResponse = models.DisplayOutputV1;
type ApiupdateDisplayMutationParams = Parameters<typeof sqDisplaysApi.updateDisplay> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDisplaysApi.updateDisplay>;

export function useApiUpdateDisplayMutation(
  options?: Omit<UseMutationOptions<ApiUpdateDisplayResponse, AxiosError<SeeqErrorData>,
    ApiupdateDisplayMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateDisplayResponse, AxiosError<SeeqErrorData>,
  ApiupdateDisplayMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateDisplayMutationParams) =>
      sqDisplaysApi.updateDisplay(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
